export enum SideMenuStorageKeys {
  IS_COLLAPSED = "SIDE_MENU_IS_COLLAPSED",
}

const sideMenuService = () => {
  const getIsCollapsed = (): boolean => {
    try {
      return localStorage.getItem(SideMenuStorageKeys.IS_COLLAPSED) === "true";
    } catch (error) {
      return false;
    }
  };

  const setIsCollapsed = (value: boolean): void => {
    try {
      localStorage.setItem(SideMenuStorageKeys.IS_COLLAPSED, String(value));
    } catch (error) {
      console.error("Error setting is collapsed:", error);
    }
  };

  const openSideMenu = (): void => {
    setIsCollapsed(false);
  };

  const collapseSideMenu = (): void => {
    setIsCollapsed(true);
  };

  return {
    getIsCollapsed,
    setIsCollapsed,
    openSideMenu,
    collapseSideMenu,
  };
};

export default sideMenuService;
